/**
 * @file Módulo raiz do projeto, gerência os demais módulos 
 * @author William Luis Alves Ferreira (git:illiamw)
 * @version 2.0.0
 */
import React from 'react';
import Cell from './Cell';
import Construtor from './Construtor';
import ControlGame from './ControlGame';
import Timer from './Timer';
import Dicas from './Modal';
import Vitoria from './Vitoria';
import Nav from './Nav';


//Compoentes Modal GameOver
import { Modal, Button, Icon } from 'rsuite';

//Componentes de roteamento
import { Link } from "react-router-dom";

/**
 * A module that shouts hello!
 * @module Board
 */

 /**
  * Construtor da classe Board responsável pela geração dos elementos DOM presentes no tabuleiro, tendo como elemento atômico Cell.js.<br>
  * Esta Classe/Módulo centraliza as 3 principais classes deste projeto:
  * <br> 
  * <ul>
  *     <li>[Construtor do nível]{@link module:ControlLevel} - Classe responsável para Pré-Configurar as dimensões dos tabuleiros, assim definindo os niveis</li>
  *     <li>[Controle do Jogo]{@link module:ControlGame} - Classe para controle dos eventos em jogo;</li>
  *     <li>[Construtor dos tabuleiros]{@link module:Construtor} - Principal classe para gerar os tabuleiros aleatórios. <br> @param [Construtor do nível]{@link module:ControlLevel} </li>
  * </ul>
 *  Resalva-se que nesta classe ocorre a @instance [Controle do Level]{@link module:ControlLevel} senvindo como instancia abstrata, mesmo que o objeto ConstrutirLevel seja criado e manipulado.
**/
export default class Board extends React.Component {
    
    constructor(props) {
        super(props);
        var ConstrutirLevel = new Construtor(props);
        this.ConstrutirLevel = ConstrutirLevel;
        this.gabarito = ConstrutirLevel.geradorGabarito(props.level.getQuantidadePalavras());
        this.conteudo = ConstrutirLevel.geradorChar(props.level.getLargura() * props.level.getAltura());
        this.ControleLevel = new ControlGame(ConstrutirLevel.palavras, props.level.getLargura(), props.level.getAltura());
        this.palavrasfixa = this.ControleLevel.getPalavras().palavras;
        this.timerResult = null;
        this.state = {
            teste: false,
            pontos: 0,
            clickBoard: false,
            tips: Array((this.ControleLevel.getPalavras().palavras.length)).fill(false),
            palavras: Array((this.ControleLevel.getPalavras().palavras.length)).fill(false),
            refereciaPalavras: Array(props.level.getLargura() * props.level.getAltura()).fill(false),
            show: false, //state Model GameOver
            consjunto: Array()
        };


    }

    /**
     *  @description Evento incorporado como objeto em cada Cell renderizado servindo como gatilho da seleção das palavras.
     *  @param {int} c referenciando a Cell ativada em relação ao vetor gabarito.
     */
    eventoUpdate(c) {
        console.log("Acertos " + this.ControleLevel.getAcertos());
        if (this.gabarito[c] !== 0) this.ControleLevel.checkLetra(c);
        console.log(this.ControleLevel.getPalavrasCertas());
        this.setState({
            pontos: this.ControleLevel.getPontos(),
            palavras: this.ControleLevel.getPalavrasCertas(),
            refereciaPalavras: this.ControleLevel.getRefPalavrasCertas()
        });

        console.log(this.state.refereciaPalavras);
        this.timerResult = document.getElementById("time_value").innerHTML;

        this.setState({
            show: this.ControleLevel.getVitoria()
        });

    }



    eventoSelect(c){
        console.log("SELECIONADO: ", c);
        var aux = this.props.state.conjunto.push(c).slice();
        this.setState({ conjunto: aux });
        console.log(this.props.state.conjunto);
    }





    /**
     *  @description Evento incorporado como objeto em cada Cell renderizado servindo como gatilho da seleção das palavras.
     *  @param {int} c referenciando a Cell ativada em relação ao vetor gabarito.
     */
    eventoDicas(c) {
        this.ControleLevel.setAjuda(c);
        console.log(this.state.tips);
        this.setState({ pontos: this.ControleLevel.getPontos() });
    }

    /**
     * @description Função que gera os buttons de forma individual
     * @param {int} lin Quantidades de linhas do tabuleiro
     * @param {int} col Quantidades de colunas do tabuleiro
     * @returns {ElementDOM} <div><button>1</button></div>
     */
    renderCells(col, lin) {
        return <Cell
            clickBoard={this.clickBoard}
            value={this.conteudo[lin * this.props.level.getLargura() + col]}
            status={0}
            ind={lin * this.props.level.getLargura() + col}
            refPC={this.state.refereciaPalavras}
            key={col * this.props.level.getLargura() + lin}
            onClick={() => { this.eventoUpdate(lin * this.props.level.getLargura() + col) }}
            onMouseDown={ () => { this.eventoSelect(lin * this.props.level.getLargura() + col) }}
        />;
    }

    /**
     * @description Função que gera os buttons compositores das colunas da matriz
     * @param {int} lin Quantidades de linhas do tabuleiro
     * @param {int} col Quantidades de colunas do tabuleiro
     * @returns {ElementDOM} <div><button>1</button><button>...</button><button>lin</button></div>
     */
    renderCol(linhas) {
        var colBoard = [];

        for (let index = 0; index < this.props.level.getLargura(); index++) {
            colBoard.push(this.renderCells(index, linhas));
        }
        return React.createElement('div', { className: "col-board", key: linhas }, colBoard);
    }
    /**
     * @description Função que gera os a Matriz de buttons
     * @returns {ElementDOM} <div><button>1</button><button>...</button><button>lin</button></div><div><button>1</button><button>...</button><button>lin</button></div><div><button>1</button><button>...</button><button>lin</button></div>
     */
    renderBoard() {
        var rowsBoard = [];
        for (let index = 0; index < this.props.level.getAltura(); index++) {
            rowsBoard.push(this.renderCol(index));
        }
        return React.createElement('div', { className: "main-board" }, rowsBoard);
    }




    renderGameOver() {
        var mostrar = {
            'display': 'block'
        };
    
        var esconder = {
            'display': 'none'
        };

        return (
            <div className="modal-personalizado"
                style={this.state.show? mostrar : esconder }
            >
                <div className="main-side">
        <Nav />
                <div className="modal-body bkColor3 opacidade fullWidth">
                    
                        <Vitoria
                        col1={
                            <div className="col fullWidth justify center medHeight">
                            <div className=" text-center center">
                                <div className='palavraCertaVitoria '>
                                        <h3>PARABÉNS!</h3>
                                </div>
                        <h5 className="Color4 text-center margin-top">Você conluiu o nível {this.props.level.getNivel()}!</h5>                                    
                                <div className='row distributed center margin-bottom margin-top'>
                                    <div className=' row visor bkColor2 destaque1'>
                                        <div className='tag Color1'>Pontuação!</div>
                                        <div className='value bkColor3'>{this.state.pontos < 0 ? '-' + ('0000' + this.state.pontos * (-1)).slice(-4) : ('0000' + this.state.pontos).slice(-4)}</div>
                                    </div>

                                    <div className='row visor bkColor2 destaque1'>
                                        <div className='tag Color1'>Cronômetro</div>
                                        <div className='value bkColor3'>
                                        {this.timerResult}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            </div>
                        }

                        col2={
                            <div className="col fullWidth justify center medHeight">
                            <div className="text-center">
                                <h5 className="Color4">Aprenda ainda mais enquanto se diverte!<br/>O jogo é randômico, então desafie-se e jogue novamente.</h5>                                    
                                <Link to="/modo">
                                <Button className='sizeButton borColor1 Color4 button1 buttonIncial'><Icon icon='gamepad' size='2x' /> Jogar</Button>
                                </Link>
                            </div>
                            </div>

                        }

                        />
                    
                </div>

            </div>
            </div>
        );
    }

    /**
     * 
     * @description Função que instância o tabuleiro como this.renderBoard(i,j) i - coluna e j- linhas
     * @returns {ElementDOM} <div><button>1</button><button>...</button><button>lin</button></div><div><button>1</button><button>...</button><button>lin</button></div><div><button>1</button><button>...</button><button>lin</button></div>
     */

    render() {
        var mostrar = {
            'display': 'flex'
        };
    
        var esconder = {
            'display': 'none'
        };
        

        return (


            <div id='view' className='col-sm center container'>
                <div className='boardContent col-sm fullWidth ajuste-vertical'>
                    <div id='board' className='row center first ' >
                        {this.renderBoard()}

                    </div>
                    <div className='col fullWidth fullHeight'>
                        <div className='row distributed3 center margin-min second' style={!this.state.show? mostrar : esconder}>
                            <div className='row visor bkColor2 destaque1'>
                                <div className='tag Color1'>Cronômetro</div>
                                <Timer />
                            </div>
                            <div className=' row visor bkColor2 destaque1'>
                                <div className='tag Color1'>Pontuação</div>
                                <div className='value bkColor3'>{this.state.pontos < 0 ? '-' + ('0000' + this.state.pontos * (-1)).slice(-4) : ('0000' + this.state.pontos).slice(-4)}</div>
                            </div>
                        </div>
                        <div id="dicas" className='row center margin-min third scrollAuto fullHeight ' style={!this.state.show? mostrar : esconder}>

                            <div>
                                <Dicas
                                    dicas={this.ConstrutirLevel.complemento}
                                    palavrasCertas={this.palavrasfixa} //ajuste em javascript para realizar copia do array
                                    onClick={() => { this.eventoDicas(50) }}
                                    tips={this.state.tips}
                                    palavras={this.state.palavras} />
                            </div>
                        </div>
                        {this.renderGameOver()}

                    </div>
                    
                </div>
            </div>
        );
    }
}